/* global Vue */
import ContactEditor from './ContactEditor'

class Bridge {

	constructor(bridgeE) {
		// 入力データの正規化
		const data = (value => {
			try {
				const data = JSON.parse(value)
				if (!data.id) return { id: null }
				return data
			} catch (e) {
				return { id: null }
			}
		})(bridgeE.value)

		this.bridgeE = bridgeE

		this.container = this.createContainer()
		this.app = new Vue({
			data() {
				return {
					value: data
				}
			},
			el: this.container,
			components: {
				ContactEditor
			},
			template: `<ContactEditor v-model="value" />`,
			watch: {
				value: {
					deep: true,
					handler () {
						bridgeE.value = JSON.stringify(this.value)
					}
				}
			}
		})
	}

	createContainer() {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
